<template>
  <div>
    <!-- Main Content -->
    <div class="main-content">
      <div class="row justify-content-center mb-2">
        <button class="btn btn-add" id="v-step-0" @click="startTour">
          Iniciar Tour de Cadastro de Filial
        </button>
      </div>
      <v-tour name="myTour" :steps="steps">
        <template slot-scope="tour">
          <transition name="fade">
            <v-step
              v-if="tour.currentStep === index"
              v-for="(step1, index) of tour.steps"
              :key="index"
              :step="step1"
              :previous-step="tour.previousStep"
              :next-step="tour.nextStep"
              :stop="tour.stop"
              :skip="tour.skip"
              :is-first="tour.isFirst"
              :is-last="tour.isLast"
              :labels="tour.labels"
            >
              <template>
                <div slot="actions">
                  <button
                    v-if="tour.currentStep != 0"
                    @click="tour.previousStep"
                    class="btn-step-back"
                  >
                    Anterior
                  </button>
                  <button
                    @click="cancelTour(tour.currentStep)"
                    class="btn-step-back"
                  >
                    Pular tour
                  </button>
                  <button
                    @click="
                      nextTour(
                        tour.currentStep,
                        tour.steps[index + 1],
                        tour.steps[index]
                      )
                    "
                    v-if="tour.currentStep != 8"
                    class="btn-step"
                  >
                    Próximo
                  </button>
                  <button
                    @click="cancelTour(tour.currentStep)"
                    v-else
                    class="btn-step"
                  >
                    Finalizar
                  </button>
                </div>
              </template>
            </v-step>
          </transition>
        </template>
      </v-tour>
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Cadastrar Filial</div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <form>
                    <div class="form-row">
                      <div class="form-group col-md-4">
                        <label for="userName" id="v-step-1">
                          <span class="required">*</span> Nome da Filial:
                        </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          class="form-control"
                          v-model="branches.title"
                          placeholder=""
                        />
                      </div>
                      <div class="form-group col-md-4">
                        <label for="userName" id="v-step-2">
                          <span class="required">*</span> Nome do Prédio:
                        </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          class="form-control"
                          v-model="branches.building_name"
                          placeholder=""
                        />
                      </div>
                      <div class="form-group col-md-4">
                        <label for="userName" id="v-step-3">
                          <span class="required">*</span> Nome da Empresa:
                        </label>
                        <select
                          v-model="branches.company_id"
                          class="form-control"
                        >
                          <option disabled selected>
                            Selecione a Empresa:
                          </option>
                          <option
                            v-for="company in companies"
                            :value="company.id"
                            :key="company.id"
                          >
                            {{ company.company_name_fantasy }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <label for="userCellphone" id="v-step-4">
                          <span class="required">*</span> E-mail:
                        </label>
                        <input
                          autocomplete="new-password"
                          class="form-control"
                          id="userEmail"
                          placeholder=""
                          type="text"
                          v-model="branches.email"
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <label for="userPhone" id="v-step-5">
                          <span class="required">*</span> Telefone:
                        </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          class="form-control"
                          v-model="branches.telephone"
                          placeholder=""
                          v-mask="'(99) 9 9999-9999'"
                        />
                      </div>
                    </div>
                    <br />
                    <div class="form-row">
                      <div class="form-group col-md-4">
                        <label for="inputZipcode" id="v-step-6">
                          <span class="required">*</span> CEP:
                        </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          class="form-control"
                          v-model="branches.cep"
                          placeholder=""
                          v-mask="'99999-999'"
                          @keyup="buscar()"
                          id="inputCep"
                        />
                      </div>
                      <div class="form-group col-md-3">
                        <label for="inputNumber" id="v-step-7">
                          <span class="required">*</span> Número:
                        </label>
                        <input
                          autocomplete="new-password"
                          id="inputNumero"
                          type="number"
                          min="0"
                          oninput="validity.valid||(value='');"
                          class="form-control"
                          placeholder=""
                          v-model="branches.number"
                        />
                      </div>
                      <div class="form-group col-md-5">
                        <label for="inputCity">
                          <span class="required">*</span> Cidade:
                        </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          class="form-control"
                          placeholder=""
                          v-model="branches.city"
                        />
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="userAddress">
                        <span class="required">*</span> Logradouro:
                      </label>
                      <input
                        autocomplete="new-password"
                        type="text"
                        id="inputLogradouro"
                        class="form-control"
                        placeholder=""
                        v-model="branches.street"
                      />
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-5">
                        <label for="inputNeighborhood">
                          <span class="required">*</span> Bairro:
                        </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          class="form-control"
                          placeholder=""
                          v-model="branches.neighborhood"
                        />
                      </div>
                      <div class="form-group col-md-4">
                        <label for="inputComplement">Complemento:</label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          class="form-control"
                          placeholder=""
                          v-model="branches.complement"
                        />
                      </div>
                      <div class="form-group col-md-3">
                        <label for="inputState">
                          <span class="required">*</span> Estado:
                        </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          class="form-control"
                          maxlength="2"
                          v-model="branches.state"
                          placeholder=""
                        />
                      </div>
                    </div>
                  </form>
                  <span class="required_fields">
                    <span class="required">*</span>
                    <strong>Campos obrigatórios</strong>
                  </span>
                  <div class="block text-right">
                    <a class="btn btn-add" @click="save" id="v-step-8">
                      <i class="fa fa-save"></i>
                      Salvar
                    </a>
                    <router-link to="/branches" class="btn btn-back">
                      <i class="fa fa-arrow-left"></i> Voltar
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";
import vSelect from "vue-select";

export default {
  data() {
    return {
      steps: [
        {
          target: "#v-step-0", // We're using document.querySelector() under the hood
          header: {
            title: "Tela de Cadastro de Filiais!",
          },
          params: {
            enableScrolling: false,
          },
          content: `Clique em <strong>próximo</strong> para continuar no tour. Caso não queira esse acompanhamento, clique em <strong>Pular tour</strong>. Se preferir poderá ver esse tour guiado a qualquer momento no botão destacado no menu superior.`,
        },
        {
          target: "#v-step-1",
          params: {
            enableScrolling: false,
          },
          content: "Digite o nome da sua Filial",
        },
        {
          target: "#v-step-2",
          params: {
            enableScrolling: false,
          },
          content: "Digite o nome do Prédio",
        },
        {
          target: "#v-step-3",
          params: {
            enableScrolling: false,
          },
          content: "Clique e selecione a Empresa",
        },
        {
          target: "#v-step-4",
          params: {
            enableScrolling: false,
          },
          content: "Digite o e-mail do responsável desta Filial",
        },
        {
          target: "#v-step-5",
          params: {
            enableScrolling: false,
          },
          content: "Digite o telefone desta Filial",
        },
        {
          target: "#v-step-6",
          params: {
            enableScrolling: false,
          },
          content:
            "Digitando o CEP o nosso sistema já preenche automaticamente Cidade, Logradouro, Bairro e Estado",
        },
        {
          target: "#v-step-7",
          params: {
            enableScrolling: false,
          },
          content: "Digite o Número desta Filial",
        },
        {
          target: "#v-step-8",
          params: {
            enableScrolling: false,
          },
          content:
            "Preenchendo todos os campos corretamente, basta clicar em Salvar.",
        },
      ],
      companies: [],
      branches: {
        title: "",
        building_name: "",
        company_id: "",
        email: "",
        telephone: "",
        cep: "",
        street: "",
        number: "",
        complement: "",
        neighborhood: "",
        city: "",
        state: "",
      },
      endereco: {},
      errors: undefined,
    };
  },
  computed: {},
  methods: {
    cancelTour(step) {
      const self = this;
      self.$tours["myTour"].skip();
      self.$store.commit("skipTour");

      let data = { finished_step: step };

      const api = self.$store.state.api + "user/finish-tour";

      self.$http.post(api, data).then((response) => {});
    },
    nextTour(step, actual_target, previous_target) {
      const self = this;

      if (step >= 31) {
        if (step >= 31) {
          $(previous_target.target).toggleClass("activeMenu");
        }
        $(actual_target.target).toggleClass("activeMenu");
      }

      if (step == 31) {
        $("#sidebar").toggleClass("active");
        setTimeout(function () {
          self.$tours["myTour"].nextStep();
        }, 500);
      } else if (step == 31) {
        $("#pagCads").toggleClass("active");
        setTimeout(function () {
          self.$tours["myTour"].nextStep();
        }, 500);
      } else if (step == 31) {
        $("#sidebar").toggleClass("active");
        $("html, body").animate({ scrollTop: 0 }, 0);
        self.$tours["myTour"].nextStep();
      } else {
        self.$tours["myTour"].nextStep();
      }
    },
    startTour() {
      let self = this;
      self.$tours["myTour"].start();
    },
    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      fd.append("title", self.branches.title);
      fd.append("building_name", self.branches.building_name);
      fd.append("company_id", self.branches.company_id);
      fd.append("email", self.branches.email);
      fd.append("telephone", self.branches.telephone);
      fd.append("street", self.branches.street);
      fd.append("neighborhood", self.branches.neighborhood);
      fd.append("complement", self.branches.complement);
      fd.append("number", self.branches.number);
      fd.append("city", self.branches.city);
      fd.append("state", self.branches.state);
      fd.append("cep", self.branches.cep);

      fd.append("_method", "POST");

      if (self.branches.id) {
        fd.append("id", self.branches.id);
        fd.append("_method", "PUT");
      }

      return fd;
    },
    save: function () {
      const self = this;
      let api = self.$store.state.api + "branches";

      let fd = self.makeFormData();

      if (self.branches.id) {
        api += "/" + self.branches.id;
      }

      self.$http
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/branches");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    buscar: function () {
      var self = this;

      self.naoLocalizado = false;

      if (/^[0-9]{5}-[0-9]{3}$/.test(this.branches.cep)) {
        $.getJSON(
          "https://viacep.com.br/ws/" + this.branches.cep + "/json/",
          function (endereco) {
            if (endereco.erro) {
              self.endereco = {};
              $("#inputNumero").focus();
              self.naoLocalizado = true;
              return;
            }
            self.endereco = endereco;
            self.branches.street = self.endereco.logradouro;
            self.branches.neighborhood = self.endereco.bairro;
            self.branches.state = self.endereco.uf;
            self.branches.city = self.endereco.localidade;
            $("#inputNumero").focus();
          }
        );
      }
    },
    getCompanies: function (id) {
      const self = this;
      const api = self.$store.state.api + "companies/?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.companies = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;

    self.getCompanies();
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Branch/Add.vue